import React from "react";
import { connect } from "react-redux";

import HurdleView from "underwriter_dashboard/shared/HurdleView";
import { HurdleProps } from "underwriter_dashboard/HurdleEditor";
import { loadApp } from "underwriter_dashboard/actions";

import PointsAndCreditsProvider from "./PointsAndCreditsProvider";
import PointsAndCreditsScreen from "./PointsAndCreditsScreen";

require("underwriter_dashboard/hurdle_editors/styles.module.scss");

interface Props extends HurdleProps {
  loadApp: any;
}

const PointsAndCredits = (props: Props) => {
  const { app, hurdle, onHide, loadApp } = props;

  return (
    <HurdleView app={app} hurdle={hurdle} onHide={onHide} hideTitle>
      <PointsAndCreditsProvider appId={app.id} reloadApp={() => loadApp(app.id)}>
        <PointsAndCreditsScreen />
      </PointsAndCreditsProvider>
    </HurdleView>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  loadApp: (appId: number) => loadApp(dispatch, appId),
});

export default connect(null, mapDispatchToProps)(PointsAndCredits);
